module.exports = __webpack_public_path__ + "static/media/estate.5e654593.png";